/* eslint-disable prettier/prettier */
import type { AdonisEndpoint } from '@tuyau/core/types'
import type { Registry } from './schema.d.ts'
import type { ApiDefinition } from './tree.d.ts'

const placeholder: any = {}

const routes = {
  'api.v1.livekit.webhook': {
    methods: ["POST"],
    pattern: '/api/v1/livekit-webhook',
    tokens: [{"old":"/api/v1/livekit-webhook","type":0,"val":"api","end":""},{"old":"/api/v1/livekit-webhook","type":0,"val":"v1","end":""},{"old":"/api/v1/livekit-webhook","type":0,"val":"livekit-webhook","end":""}],
    types: placeholder as Registry['api.v1.livekit.webhook']['types'],
  },
  'api.v1.rss.audio': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/rss/audio/:userId/*',
    tokens: [{"old":"/api/v1/rss/audio/:userId/*","type":0,"val":"api","end":""},{"old":"/api/v1/rss/audio/:userId/*","type":0,"val":"v1","end":""},{"old":"/api/v1/rss/audio/:userId/*","type":0,"val":"rss","end":""},{"old":"/api/v1/rss/audio/:userId/*","type":0,"val":"audio","end":""},{"old":"/api/v1/rss/audio/:userId/*","type":1,"val":"userId","end":""},{"old":"/api/v1/rss/audio/:userId/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['api.v1.rss.audio']['types'],
  },
  'api.v1.rss.image': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/rss/image/:userId/*',
    tokens: [{"old":"/api/v1/rss/image/:userId/*","type":0,"val":"api","end":""},{"old":"/api/v1/rss/image/:userId/*","type":0,"val":"v1","end":""},{"old":"/api/v1/rss/image/:userId/*","type":0,"val":"rss","end":""},{"old":"/api/v1/rss/image/:userId/*","type":0,"val":"image","end":""},{"old":"/api/v1/rss/image/:userId/*","type":1,"val":"userId","end":""},{"old":"/api/v1/rss/image/:userId/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['api.v1.rss.image']['types'],
  },
  'api.v1.rss.feed': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/rss/:userId/*',
    tokens: [{"old":"/api/v1/rss/:userId/*","type":0,"val":"api","end":""},{"old":"/api/v1/rss/:userId/*","type":0,"val":"v1","end":""},{"old":"/api/v1/rss/:userId/*","type":0,"val":"rss","end":""},{"old":"/api/v1/rss/:userId/*","type":1,"val":"userId","end":""},{"old":"/api/v1/rss/:userId/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['api.v1.rss.feed']['types'],
  },
  'api.v1.test.index': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/test',
    tokens: [{"old":"/api/v1/test","type":0,"val":"api","end":""},{"old":"/api/v1/test","type":0,"val":"v1","end":""},{"old":"/api/v1/test","type":0,"val":"test","end":""}],
    types: placeholder as Registry['api.v1.test.index']['types'],
  },
  'api.v1.test.job.store': {
    methods: ["POST"],
    pattern: '/api/v1/test/job',
    tokens: [{"old":"/api/v1/test/job","type":0,"val":"api","end":""},{"old":"/api/v1/test/job","type":0,"val":"v1","end":""},{"old":"/api/v1/test/job","type":0,"val":"test","end":""},{"old":"/api/v1/test/job","type":0,"val":"job","end":""}],
    types: placeholder as Registry['api.v1.test.job.store']['types'],
  },
  'api.v1.test.job.show': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/test/job/:jobId',
    tokens: [{"old":"/api/v1/test/job/:jobId","type":0,"val":"api","end":""},{"old":"/api/v1/test/job/:jobId","type":0,"val":"v1","end":""},{"old":"/api/v1/test/job/:jobId","type":0,"val":"test","end":""},{"old":"/api/v1/test/job/:jobId","type":0,"val":"job","end":""},{"old":"/api/v1/test/job/:jobId","type":1,"val":"jobId","end":""}],
    types: placeholder as Registry['api.v1.test.job.show']['types'],
  },
  'api.v1.test.error': {
    methods: ["POST"],
    pattern: '/api/v1/test/error',
    tokens: [{"old":"/api/v1/test/error","type":0,"val":"api","end":""},{"old":"/api/v1/test/error","type":0,"val":"v1","end":""},{"old":"/api/v1/test/error","type":0,"val":"test","end":""},{"old":"/api/v1/test/error","type":0,"val":"error","end":""}],
    types: placeholder as Registry['api.v1.test.error']['types'],
  },
  'api.v1.jobs.grade_sync': {
    methods: ["POST"],
    pattern: '/api/v1/jobs/grade_sync',
    tokens: [{"old":"/api/v1/jobs/grade_sync","type":0,"val":"api","end":""},{"old":"/api/v1/jobs/grade_sync","type":0,"val":"v1","end":""},{"old":"/api/v1/jobs/grade_sync","type":0,"val":"jobs","end":""},{"old":"/api/v1/jobs/grade_sync","type":0,"val":"grade_sync","end":""}],
    types: placeholder as Registry['api.v1.jobs.grade_sync']['types'],
  },
  'api.v1.jobs.show': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/jobs/:id',
    tokens: [{"old":"/api/v1/jobs/:id","type":0,"val":"api","end":""},{"old":"/api/v1/jobs/:id","type":0,"val":"v1","end":""},{"old":"/api/v1/jobs/:id","type":0,"val":"jobs","end":""},{"old":"/api/v1/jobs/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['api.v1.jobs.show']['types'],
  },
  'api.v1.assignments.rubrics.upsert': {
    methods: ["POST"],
    pattern: '/api/v1/assignments/rubrics',
    tokens: [{"old":"/api/v1/assignments/rubrics","type":0,"val":"api","end":""},{"old":"/api/v1/assignments/rubrics","type":0,"val":"v1","end":""},{"old":"/api/v1/assignments/rubrics","type":0,"val":"assignments","end":""},{"old":"/api/v1/assignments/rubrics","type":0,"val":"rubrics","end":""}],
    types: placeholder as Registry['api.v1.assignments.rubrics.upsert']['types'],
  },
  'api.v1.users.update_me': {
    methods: ["PATCH"],
    pattern: '/api/v1/users/me',
    tokens: [{"old":"/api/v1/users/me","type":0,"val":"api","end":""},{"old":"/api/v1/users/me","type":0,"val":"v1","end":""},{"old":"/api/v1/users/me","type":0,"val":"users","end":""},{"old":"/api/v1/users/me","type":0,"val":"me","end":""}],
    types: placeholder as Registry['api.v1.users.update_me']['types'],
  },
  'api.v1.users.score_mapping_defaults.update': {
    methods: ["PUT"],
    pattern: '/api/v1/users/me/score-mapping-defaults',
    tokens: [{"old":"/api/v1/users/me/score-mapping-defaults","type":0,"val":"api","end":""},{"old":"/api/v1/users/me/score-mapping-defaults","type":0,"val":"v1","end":""},{"old":"/api/v1/users/me/score-mapping-defaults","type":0,"val":"users","end":""},{"old":"/api/v1/users/me/score-mapping-defaults","type":0,"val":"me","end":""},{"old":"/api/v1/users/me/score-mapping-defaults","type":0,"val":"score-mapping-defaults","end":""}],
    types: placeholder as Registry['api.v1.users.score_mapping_defaults.update']['types'],
  },
  'api.v1.users.update': {
    methods: ["PATCH"],
    pattern: '/api/v1/users/:firebaseId',
    tokens: [{"old":"/api/v1/users/:firebaseId","type":0,"val":"api","end":""},{"old":"/api/v1/users/:firebaseId","type":0,"val":"v1","end":""},{"old":"/api/v1/users/:firebaseId","type":0,"val":"users","end":""},{"old":"/api/v1/users/:firebaseId","type":1,"val":"firebaseId","end":""}],
    types: placeholder as Registry['api.v1.users.update']['types'],
  },
  'api.v1.admin.slide_decks.update': {
    methods: ["PUT"],
    pattern: '/api/v1/admin/slide_decks/:id',
    tokens: [{"old":"/api/v1/admin/slide_decks/:id","type":0,"val":"api","end":""},{"old":"/api/v1/admin/slide_decks/:id","type":0,"val":"v1","end":""},{"old":"/api/v1/admin/slide_decks/:id","type":0,"val":"admin","end":""},{"old":"/api/v1/admin/slide_decks/:id","type":0,"val":"slide_decks","end":""},{"old":"/api/v1/admin/slide_decks/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['api.v1.admin.slide_decks.update']['types'],
  },
  'api.v1.slide_decks.index': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/slide_decks',
    tokens: [{"old":"/api/v1/slide_decks","type":0,"val":"api","end":""},{"old":"/api/v1/slide_decks","type":0,"val":"v1","end":""},{"old":"/api/v1/slide_decks","type":0,"val":"slide_decks","end":""}],
    types: placeholder as Registry['api.v1.slide_decks.index']['types'],
  },
  'api.v1.rss.url': {
    methods: ["GET","HEAD"],
    pattern: '/api/v1/rss/url',
    tokens: [{"old":"/api/v1/rss/url","type":0,"val":"api","end":""},{"old":"/api/v1/rss/url","type":0,"val":"v1","end":""},{"old":"/api/v1/rss/url","type":0,"val":"rss","end":""},{"old":"/api/v1/rss/url","type":0,"val":"url","end":""}],
    types: placeholder as Registry['api.v1.rss.url']['types'],
  },
  'admin.queues.wildcard': {
    methods: ["HEAD","OPTIONS","GET","POST","PUT","PATCH","DELETE"],
    pattern: '/admin/queues/*',
    tokens: [{"old":"/admin/queues/*","type":0,"val":"admin","end":""},{"old":"/admin/queues/*","type":0,"val":"queues","end":""},{"old":"/admin/queues/*","type":2,"val":"*","end":""}],
    types: placeholder as Registry['admin.queues.wildcard']['types'],
  },
  'admin.queues': {
    methods: ["HEAD","OPTIONS","GET","POST","PUT","PATCH","DELETE"],
    pattern: '/admin/queues',
    tokens: [{"old":"/admin/queues","type":0,"val":"admin","end":""},{"old":"/admin/queues","type":0,"val":"queues","end":""}],
    types: placeholder as Registry['admin.queues']['types'],
  },
} as const satisfies Record<string, AdonisEndpoint>

export { routes }

export const registry = {
  routes,
  $tree: {} as ApiDefinition,
}

declare module '@tuyau/core/types' {
  export interface UserRegistry {
    routes: typeof routes
    $tree: ApiDefinition
  }
}
